<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'contactus'" [businessName]="vm.businessName" [permitNo]="vm.permitNo">
</cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row section-header">
        <div class="col pt-4">Contact Us</div>
    </div>
  
    <div class="row pt-4">
        <div class="col-lg-6">
            <p>Need help with something?</p>
            <p>Leave us a message regarding Hydrotrak and we will get back to you shortly, or simply call us on <b>(03) 1300 249 140</b> – Option 4</p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="row">
                <div class="col">
                    <label>Subject *</label>
                    <input type="text" class="form-control" [ngClass]="{'is-invalid': !!error('subject')}"
                        name="subject" [(ngModel)]="vm.subject">
                    <div class="invalid-feedback">
                        {{error('subject')}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Message *</label>
                    <textarea rows="3" class="form-control" [ngClass]="{'is-invalid': !!error('message')}"
                        name="message" [(ngModel)]="vm.message"></textarea>
                    <div class="invalid-feedback">
                        {{error('message')}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col text-right pt-2">
                    <button class="btn btn-sm btn-primary" style="width:75px;" type="button"
                        (click)="sendEmail()">Send</button>
                </div>
            </div>
        </div>
    </div>

</div>